var map = {
	"./arrow-right.svg": 796,
	"./caret-down.svg": 92352,
	"./checkbox.svg": 42660,
	"./coin.svg": 80480,
	"./farm-add.svg": 43980,
	"./lock.svg": 33992,
	"./plus-solid.svg": 54204,
	"./swap-icon.svg": 64439,
	"./unlock.svg": 38168,
	"./vector.svg": 13380,
	"./xtz-crunch.svg": 16935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36316;